import { isBrowser } from "./helpers/env";

import { format } from "timeago.js/lib/format";
import { IOption } from "../front/types";
import "./timeago";
import detector from "detector";

export * from "./helpers/solfaParser";
export * from "./helpers/getLyricWidth";
export * from "./helpers/modifiers";
export * from "./helpers/solfa";
export * from "./helpers/checkPlayable";
export * from "./helpers/abc";
export * from "./helpers/rhythm";
export * from "./helpers/taskTypes";
export * from "./helpers/locales";
export * from "./helpers/meta";
export * from "./helpers/getAccidentals";
export * from "./helpers/getNoteOffset";
export * from "./helpers/pitchNotation";
export * from "./helpers/embed";
export * from "./helpers/moderation";
export * from "./helpers/credentials";
export * from "./helpers/intervals";
export * from "./helpers/account";
export * from "./helpers/score";
export * from "./helpers/getPlayItems";
export * from "./helpers/rhytCardTypes";
export * from "./helpers/appStores";

export { default as motherTongues, isMotherTongue } from "./motherTongues";

export const upperMenuHeight = 50;

export const aspectRatio = {
    width: 1280,
    height: 720,
};

export const timeago = {
    format,
};

export const getSelectValue = <T extends string | number>(array: IOption<T>[], value: IOption<T>["value"]) => {
    let index = array.findIndex(a => a.value === value);
    if (index === -1) return "";
    return array[index].label;
};

export const defaultCover = "default-cover";

export const battleOfTheHunsId = "5c5b6598561c2d0017dad610";
export const christmasId = "5dc5c706a88fad001ea4c1f8";

export const isMobile = isBrowser ? (detector.os.name === "ios" || detector.os.name === "android") : false;
